export enum KobakContext {
  operatore = "operatore",
  concessionario = "concessionario",
  capoArea = "capoArea",
}

export type UserType = "PRAD" | "ADAM" | "ADCO" | "COCA" | "COOP" | "NOSE";

// Some stores/frontend frameworks (Refs/Proxies) now represent the user_type
// as an object with `value` and `label`, e.g. `Proxy { value: 'PRAD', label: 'Global Admin' }`.
// Represent that shape here and allow `user_type` fields to be either the
// simple `UserType` string or an object with `value: UserType` and optional `label`.
export interface UserTypeObject {
  value: UserType;
  label?: string;
}

export enum UserTypeEnum {
  PRAD = "PRAD", // Global Admin
  ADAM = "ADAM", // Administrative Admin
  ADCO = "ADCO", // Sales Admin
  COCA = "COCA", // Area Manager
  COOP = "COOP", // Operator
  NOSE = "NOSE", // Not Set
}

export interface User {
  user?: number;
  id?: number;
  nome?: string;
  foto?: string;
  email?: string;
  url?: string;
  lang?: string;
  user_type?: UserType | UserTypeObject;
  country?: string;
}

export interface UserInfo {
  id: number;
  nome: string;
  foto?: string;
  email?: string;
  url?: string;
  lang?: string;
  pusher_channel?: string;
  is_hijacked?: boolean;
  user_type?: UserType | UserTypeObject;
  country?: string;
}

export function hasPermission(
  currentUserType: UserType | UserTypeObject | undefined,
  allowedUserTypes: UserType[],
): boolean {
  if (!currentUserType) return false;
  const typeValue: UserType | undefined =
    typeof currentUserType === "string"
      ? currentUserType
      : currentUserType &&
          typeof currentUserType === "object" &&
          "value" in currentUserType
        ? (currentUserType as UserTypeObject).value
        : undefined;

  if (!typeValue) return false;
  return allowedUserTypes.includes(typeValue);
}
